import { Link } from 'react-router-dom';
import { Container, Card } from '../../components/ui';
import FormularioIdPaciente from '../../components/FormularioIdPaciente';
import IconoUsuario from './IconoUsuario';
import { useAcceso } from './useAcceso';
import './Acceso.css';

export default function Acceso() {
  const { confirmar } = useAcceso();

  return (
    <Container narrow>
      <Card className="acceso-card">
        <header className="acceso-header">
          <div className="acceso-icono" aria-hidden="true">
            <IconoUsuario />
          </div>
          <h1 className="acceso-titulo">Ingresá con tu ID</h1>
          <p className="acceso-sub">
            En esta etapa no manejamos sesión: ingresá tu identificador de usuario para acceder a tus turnos.
          </p>
        </header>

        <FormularioIdPaciente onConfirmar={confirmar} />

        <p className="acceso-footer">
          ¿Solo querés buscar un turno? <Link to="/buscar">Buscá desde acá</Link>
        </p>
      </Card>
    </Container>
  );
}
